import actionTypes from "../../actionTypes";


export const getAllAssignedDataAction = (data) => ({
  type: actionTypes.adminTypes.myQueries.GET_ALL_ASSIGNED_QUERIES,
  payload: data,
});

export const getAllAssignedSupportDataAction = (data) => ({
  type: actionTypes.adminTypes.myQueries.GET_ALL_ASSIGNED_QUERIES_SUPPORT_TAB,
  payload: data,
});

export const putQueryAction = (data) => ({
  type: actionTypes.adminTypes.myQueries.PUT_QUERY,
  payload: data,
});

export const putUnreadCountAction = (data) => ({
  type: actionTypes.adminTypes.myQueries.PUT_UNREAD_COUNT,
  payload: data,
});


export const putIsReadAction = (data) => ({
  type: actionTypes.adminTypes.myQueries.PUT_IS_READ,
  payload: data,
})